/**
 * `/signin/error` — TASK 7.4 Step 1 (AC 1.7, ui-contract §9).
 *
 * Extracted VERBATIM from the mock's `rSErr` block (L74-83):
 *
 *   div[data-screen-label="Sign in error"] .sm-screen-center.sm-screen-center--text
 *     div .sm-auth-card--wide .sm-anim-up
 *       div    .sm-glyph--error                          "WIRES CROSSED"    L77
 *       h1     .sm-status-title--20 [data-h1][tabindex=-1] "Sign-in didn't finish"  L78
 *       p      .sm-body                                   "Network hiccup…" L79
 *       button .sm-btn .sm-btn--retry                     "Retry sign-in"   L80
 *
 * The retry is the mock's own behaviour (`signinRetry: () => this._go('#/signin')`,
 * L946) — back to the sign-in screen, where one tap restarts the REAL OIDC
 * round-trip. That is what makes the error "retriable" per AC 1.7.
 *
 * The server sends users here for every recoverable failure of the callback:
 * a provider-side error or a cancelled consent screen, a state/nonce mismatch,
 * and a token-exchange or ID-token verification failure
 * (`apps/api/src/routes/auth.ts` → `SIGNIN_ERROR_PATH`). It never lands here
 * for a non-allowlisted account — that is `/signin/denied`.
 *
 * @module
 */

import { TESTIDS } from '@streamymusic/shared';

import { append, el } from '../../components/primitives/dom.js';
import { Button } from '../../components/primitives/Button.js';

/**
 * @param {{ onRetry?: () => void }} [options]
 * @returns {HTMLElement}
 */
export function SignInError(options = {}) {
  const { onRetry } = options;

  const card = el('div', { className: 'sm-auth-card--wide sm-anim-up' });
  append(
    card,
    el('div', { className: 'sm-glyph--error', text: 'WIRES CROSSED' }), // L77
    el('h1', {
      className: 'sm-status-title sm-status-title--20',
      text: "Sign-in didn't finish",
      testId: TESTIDS.PAGE_HEADING,
      attrs: { tabindex: '-1', 'data-h1': '' },
    }), // L78
    el('p', {
      className: 'sm-body',
      text: 'Network hiccup or the consent screen got closed. No harm done — run it back.',
    }), // L79
    Button({
      label: 'Retry sign-in',
      variant: 'retry',
      testId: TESTIDS.RETRY_SIGN_IN_BUTTON,
      ...(onRetry === undefined ? {} : { onClick: onRetry }),
    }), // L80
  );

  return append(
    el('div', {
      className: 'sm-screen-center sm-screen-center--text',
      attrs: { 'data-screen-label': 'Sign in error' },
    }),
    card,
  );
}
